<template lang="pug">
  v-container.px-10(fluid)
    v-row.table__top
      v-col.py-0
      v-col.pt-4(cols="auto")
        g-btn.h8(
          color="primary",
          @click.stop="dialogContactParty = true, contact = getCleanContact()"
          :disabled="disabledBtn"
        ) Create Contact
    v-dialog(v-model='dialogContactParty', persistent, max-width="979")
      v-card.px-10.py-5
        v-icon.dialog__close(@click='dialogContactParty = false; disableSaveContactParty = false;') mdi-close
        v-card-text
          template
            .h2.primary--text Create Contact for {{ partyName }}
            v-container.px-10(fluid)
              v-row
                v-col(cols="2")
                  v-text-field(
                    v-model="contact.title",
                    label="Title",
                    :error-messages="errors['contact.title']",
                  )
                v-col(cols="3")
                  v-text-field(
                    v-model="contact.name",
                    label="Name",
                    :error-messages="errors['contact.name']",
                  )
                v-col(cols="3")
                  v-text-field(
                    v-model="contact.lastName",
                    label="Last Name"
                    :error-messages="errors['contact.lastName']",
                  )
                v-col(cols="3")
                  v-text-field(
                    v-model="contact.preferredName",
                    label="Preferred Name"
                  )
                v-col(cols="3")
                  v-text-field(
                    v-model="contact.preferredLanguage",
                    label="Preferred Language"
                  )
                v-col(cols="4")
                  v-text-field(
                    v-model="contact.eMail",
                    label="E Mail",
                    :error-messages="errors['contact.eMail']",
                  )
                v-col(cols="4")
                  v-text-field(
                    v-model="contact.eMail2",
                    label="E Mail 2"
                  )
                v-col(cols="3")
                  v-text-field(
                    v-model="contact.phoneNumber",
                    label="Phone Number"
                  )
                v-col(cols="3")
                  v-text-field(
                    v-model="contact.phoneNumber2",
                    label="Phone Number 2"
                  )
                v-col(cols="5")
                  v-text-field(
                    filled,
                    v-model="contact.remarks",
                    label="Remarks",
                    :error-messages="errors['contact.Remarks']",
                  )
            v-row
              v-spacer
              v-col(cols="auto")
                g-btn(color="success", @click="createContactParty", :disabled="disableSaveContactParty") Save contact
</template>

<style lang="scss" scoped>
.g-data-table .row.table__top {
  flex-grow: 0;
}

.dialog__close {
  position: absolute;
  right: 15px;
  top: 15px;
}
</style>

<script>
import axios from 'axios'

export default {
  name: 'contact-party',
  props: ['party'],
  data: function () {
    return {
      dialogContactParty: false,
      disableSaveContactParty: false,
      contact: this.getCleanContact()
    }
  },
  computed: {
    errors(){
     return this.$store.state.errors;
    },
    disabledBtn() {
      return _.isNil(_.get(this.party, 'id'));
    },
    partyName() {
      return _.get(this.party, 'name');
    }
  },
  methods: {
    /**
     * Attach a new contact to partyFrom
     */
    async createContactParty() {
      try {
        let contactParty = this.mapPartyContact();
        await axios.post('entity/graph', contactParty)
        this.disableSaveContactParty = true;
        this.$emit('post');
        this.dialogContactParty = false;
        this.disableSaveContactParty = false;
      } catch (error) {
      }
    },
    /*
    Create a PartyContact object, ready to save
    */
    mapPartyContact() {
      return {
        partyId: this.party.id,
        contact: this.contact,
        _Entity: 'contactParty',
        entityState: 4
      };
    },
    /*
    Get Clean contact ready to set values
    */
    getCleanContact(){
      return {
        title: null,
        name: null,
        lastName: null,
        preferredName: null,
        preferredLanguage: null,
        eMail: null,
        eMail2: null,
        phoneNumber: null,
        phoneNumber2: null,
        remarks: null,
        _Entity: 'Contact',
        entityState: 4
      }
    }

  }
}
</script>
